// src/services/configuration.ts
import { apiClient } from './api';
import { CompanyConfig } from '../types';

export interface UpdateConfigurationRequest {
  smtpServer: string | null;
  smtpPort: number | null;
  smtpUsername: string | null;
  smtpPassword?: string;       // only sent if user entered a new value
  smtpUseSsl: boolean;
  dkimDomain: string | null;
  dkimSelector: string | null;
  dkimPrivateKey?: string;     // only sent if user entered a new value
  emailsPerHour: number;
  emailsPerDay: number;
  webhookUrl: string | null;
  webhookSecret?: string;      // only sent if user entered a new value
}

class ConfigurationService {
  async getConfiguration(): Promise<CompanyConfig> {
    const response = await apiClient.get<CompanyConfig>('/dashboard/config');
    return response.data;
  }

  async updateConfiguration(config: UpdateConfigurationRequest): Promise<CompanyConfig> {
    const response = await apiClient.put<CompanyConfig>('/dashboard/config', config);
    return response.data;
  }

  async testSmtpConnection(config: {
    smtpServer: string;
    smtpPort: number;
    smtpUsername: string;
    smtpPassword: string;
    smtpUseSsl: boolean;
  }): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/dashboard/test-smtp', config);
    return response.data;
  }
}

export const configurationService = new ConfigurationService();
